<script setup>
import AppIcon from 'module/icon/AppIcon.vue';
import { ref } from 'vue';

const props = defineProps({
    type: {
        type: String,
        required: true,
    },
    iconSuccess: {
        type: Boolean,
        default: false,
    },
    iconInfo: {
        type: Boolean,
        default: false,
    },
    iconError: {
        type: Boolean,
        default: false,
    },
    message: {
        type: String,
        default: '',
    },
    link: {
        type: String,
        default: '',
    },
    linkText: {
        type: String,
        default: '',
    },
    visible: {
        type: Boolean,
        default: false,
    },
});

const isVisible = ref(props.visible);
function hide() {
    isVisible.value = false;
}
</script>

<template>
    <div :class="['m-notificationBar', `m-notificationBar--${type}`, { 'm-notificationBar--visible': isVisible }]">
        <div class="m-notificationBar__inner">
            <div :class="['m-notificationBar__icon', `m-notificationBar__icon--${type}`]">
                <AppIcon
                    v-if="iconSuccess"
                    name="check"
                    size="large"
                />
                <AppIcon
                    v-if="iconInfo"
                    name="info"
                    size="large"
                />
                <AppIcon
                    v-if="iconError"
                    name="alert"
                    size="large"
                />
            </div>

            <div class="m-notificationBar__message">
                {{ message }}
                <a
                    v-if="link"
                    :href="link"
                    :class="[`m-notificationBar__hyperlink--${type}`]"
                >{{ linkText }}</a>
            </div>

            <button
                :class="['m-notificationBar__close', `m-notificationBar__close--${type}`]"
                @click="hide"
            >
                <AppIcon
                    name="cross"
                    size="large"
                />
            </button>
        </div>
    </div>
</template>

<style lang="scss">
@use "styles";
</style>
